import { call, put } from "redux-saga/effects";

import { apiRouting, notify } from "services";
import { ICreateRequest } from "interfaces/create-duck";
import { requestErrorHandler } from "utils";
import { CreatePickingQuarentineActions } from "store/ducks/picking-quarentines";

export function* createPickingQuarentineRequest(action: any) {
  try {
    const { postData, onSuccess } = action as ICreateRequest;

    const { data: responseBody } = yield call(
      apiRouting.post,
      `/picking-quarentines`,
      postData
    );

    const { data } = responseBody;
    yield put(CreatePickingQuarentineActions.success(data));
    notify("success", "Carga cadastrada com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(CreatePickingQuarentineActions.failure(errorMessage));
  }
}
